import { ErrorHandler, Injectable } from "@angular/core";
import { StateService } from '@app/shared';
import { environment } from 'environments/environment';


@Injectable()
export class RavenErrorHandler implements ErrorHandler {
    constructor(private state: StateService) { }
    handleError(err: any): void {
        let user = this.state.getParameter('userLogin');
       // if (!environment.production)
            console.log(err);
    }
}



// WEBPACK FOOTER //
// ./src/app/raven-handler.ts